import classNames from 'classnames';
import React, { ReactElement } from 'react';
import styles from './ButtonGroup.module.scss';
import { BackArrowIcon } from "@kursk/components/ui/icons";

export interface ICustomButtonGroupProps {
  next?: () => void;
  previous?: () => void;
  goToSlide?: () => void;
  carouselState?: {
    currentSlide: number;
  }
  totalItems?: number
}

export function ButtonGroup({ next, previous, carouselState, totalItems }: ICustomButtonGroupProps): ReactElement {
  const { currentSlide } = carouselState;

  return (
    <div className={classNames(styles.buttonGroup, "carousel-button-group")}>
      <button className={classNames(styles.button, styles.left)} onClick={() => previous()}>
        <BackArrowIcon width={18} height={13} />
      </button>
      <div className={styles.counterText}>{`${currentSlide + 1}/${totalItems}`}</div>
      <button className={classNames(styles.button, styles.right)} onClick={() => next()}>
        <BackArrowIcon width={18} height={13} />
      </button>
    </div>
  );
}
